import axios from "../../axios";
import { Commit } from 'vuex'

const baseURL = "/inventory-logs";

export default ({
    namespaced: true,
    state : {
        inventory_logs: [],
        item:{},
        status: 'loading'
    },
    actions : {
        async index({commit}: {commit: Commit}, payload={}){
            commit('SET_STATUS', 'loading')
            const { data } = await axios.get(`${baseURL}`, {params: {...payload}});
            commit('SET_ITEMS', data)
            commit('SET_STATUS', 'completed')
            return data
        },
    },
    mutations:{
        SET_ITEMS(state:any, data: any){
            state.inventory_logs = data.data;
        },
        SET_STATUS(state: any, payload: string){
            state.status = payload;
        },
    },
    getters:{
        items(state: any){
            return state.inventory_logs;
        },
        status(state: any){
            return state.status;
        }
    }
});




